// ABSOLUTE PATHS (used in project)
export const ROUTING_ABSOLUTE_PATH_FOURNISSEUR = "/fournisseurs"

export const ROUTING_ABSOLUTE_PATH_FOURNISSEUR_LISTING = `${ROUTING_ABSOLUTE_PATH_FOURNISSEUR}/listing`
export const ROUTING_ABSOLUTE_PATH_FOURNISSEUR_CREATE = `${ROUTING_ABSOLUTE_PATH_FOURNISSEUR}/create`

// RELATIVE PATHS (used in Routing.tsx only)
export const ROUTING_RELATIVE_PATH_FOURNISSEUR_LISTING = "listing"
export const ROUTING_RELATIVE_PATH_FOURNISSEUR_CREATE = "create"
